import { workplaceTypes } from "../types";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'
import { ModalContainerLoadsheet } from "../Modal/ModalContainerLoadsheet";
import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import {ModalContainerComment} from "../Modal/ModalComment";
import {ModalContainerReject} from "../Modal/ModalReject";
import {ModalContainerNotLS} from "../Modal/ModalNotLS";
import {appNotification} from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

let LOADSHEET = {};
const MIN_TEXT_SCALE = 0.8;
const MAX_TEXT_SCALE = 1.6;
let currentScale = 1;
const MODAL_CONTAINER_ID = "modalLoadsheetText";

function getLoadsheetStatusClass(statusID) {
	switch (statusID) {
		case "0": //"Проект"
			return "bg-orange";
		case "1": //"Подтверждён"
		case "2": //"Подписан"
			return "bg-green";
		case "3": //"Отклонён"
			return "bg-decline";
		default:
			return "bg-primary";
	}
}

function zoomIn(selector) {
	const container = document.querySelector(selector);
	if (currentScale < MAX_TEXT_SCALE) {
		currentScale += 0.2;
		container.classList.add("zoomed");
		container.style.transform = `scale(${currentScale})`;
	}
}
function zoomOut(selector) {
	const container = document.querySelector(selector);
	if (currentScale > MIN_TEXT_SCALE) {
		currentScale -= 0.2;
		container.classList.add("zoomed");
		container.style.transform = `scale(${currentScale})`;
	}
}

export var LoadsheetPage = {
	controller: function () {
		var self = this;
		var im;

		if (!user.exists()) {
			m.route("/login");
			return;
		}

		interval.clearAll();

		loader.show();

		if (user.get("state.workplace") === workplaceTypes.driver) {
			this.topMenu = [
				{ title: "Задачи", url: "/vehicle/tasks", icon: "fa-tasks" },
				{ title: "Профиль", url: "/profile", icon: "fa-user" },
				isEnabledMsg()
					? {
							title: "Сообщения",
							url: "/message",
							icon: isUnreadMsg() ? "fa-envelope-o" : "fa-envelope-open-o",
					  }
					: {},
				{ title: "Выйти", url: "/logout", icon: "fa-sign-out" },
			];

			if (user.get("state.vehicleFreeTasksAvailable")) {
				this.topMenu.unshift({
					title: "Свободные",
					url: "/vehicle/tasks/free",
					icon: "fa-car",
				});
			}
		} else if (user.get("state.workplace") === workplaceTypes.agent) {
			this.topMenu = [
				{ title: "Задачи", url: "/agent/tasks", icon: "fa-tasks" },
				{ title: "Рейсы", url: "/agent/flights", icon: "fa-plane" },
				{ title: "Профиль", url: "/profile", icon: "fa-user" },
				isEnabledMsg()
					? {
							title: "Сообщения",
							url: "/message",
							icon: isUnreadMsg() ? "fa-envelope-o" : "fa-envelope-open-o",
					  }
					: {},
				{ title: "Выйти", url: "/logout", icon: "fa-sign-out" },
			];
		} else {
			this.topMenu = [
				{ title: "Задачи", url: "/", icon: "fa-tasks" },
				{ title: "Профиль", url: "/profile", icon: "fa-user" },
				isEnabledMsg()
					? {
							title: "Сообщения",
							url: "/message",
							icon: isUnreadMsg() ? "fa-envelope-o" : "fa-envelope-open-o",
					  }
					: {},
				{ title: "Выйти", url: "/logout", icon: "fa-sign-out" },
			];
		}

		this.data = m
			.request({
				method: "GET",
				url: "/api/task/" + m.route.param("taskId") + "/getLoadSheet",
			})
			.then(
				function (response) {
					if(!response?.loadsheet) {
						loader.hide();
						alert("Loadsheet недоступен. Обратитесь к администратору");
					}

					if (typeof response.loadsheet?.status === "number") {
						ModalContainerNotLS.init()
						ModalContainerNotLS.open()
						return response
					}
					server.setOnline();
					loader.hide();
					storage.config = response.config;

					appNotification.list = response.notifications;

					server.initPing();
					appNotification.init();

					LOADSHEET = response.loadsheet;
					return response;
				},
				function (response) {
					if (response && response.message) {
						self.errmsg = m(".alert.alert-danger", response.message);
					} else {
						server.setOffline();
					}
					loader.hide();
				},
			);
		this.isCancel = false
		this.setCancel = (val) => {
			this.isCancel = !!val
		}

		this.cancelComment = ''
		this.setCancelComment = (str) => this.cancelComment = str

		this.maxlength =500

		this.taskId = m.route.param('taskId')

		this.getStatusName = (id) => {
			const hashMap = {
				1: 'Подтверждено ',
				2: 'Подписано ',
				3: 'Отклонено '
			}
			return hashMap[id]
		}

	},
	view: function (ctrl) {
		return [
			ModalContainerLoadsheet.init(MODAL_CONTAINER_ID),
			m.component(HeaderMenuBlock, {
				time: ctrl.data()?.time,
				menu: ctrl.topMenu,
			}),
			m(
				".main-container",
				!LOADSHEET
					? [
							m(".loadsheet-header", [
								m("i.fa.fa-2x.fa-arrow-left.arrow-icon", {
									onclick: function () {
										m.route(`/task/${ctrl.taskId}/info`)									},
								}),
							]),
							m(".empty-loadsheet", "LS к данному рейсу отсутствует"),
					  ]
					: [
							m(".loadsheet-header", [
								m("i.fa.fa-2x.fa-arrow-left.arrow-icon", {
									onclick: function () {
										m.route(`/task/${ctrl.taskId}/info`)
									},
								}),
								m(".loadsheet-title", [
									m(".loadsheet-name", `Loadsheet${ctrl.isCancel ? '/Отклонение' : ''}`),
									m(".loadsheet-text", LOADSHEET.title),
								]),
								m(
									".loadsheet-status",
									{
										class: getLoadsheetStatusClass(LOADSHEET.idState),
									},
									LOADSHEET.state_name,
								),
							]),
							m(".loadsheet-body", [
								LOADSHEET.idState !== 0
									? m(
										".loadsheet-confirmed[style='display: none;']",
										{
											style:
												LOADSHEET.idState === "0" || LOADSHEET.idState === "3"
													? "display: none;"
													: "display: block;",
										},
										[
											m(
												"span",
												ctrl.getStatusName(LOADSHEET.idState)
											),
											m("span", [
												m("b", LOADSHEET.fio + " " + LOADSHEET.dtState),
											]),
										],
									)
								: '',
								!ctrl.isCancel
									? [
										m(
											"button.btn-lg.loadsheet-confirm-btn",
											{
												disabled: LOADSHEET.idState === 0 ? false : true,
												class: LOADSHEET.idState === 0 ? "bg-confirm" : "bg-grey",
												onclick: function () {
													loader.show();
													m.request({
														method: "PUT",
														url:
															"/api/task/" +
															m.route.param("taskId") +
															"/setLoadSheet",
														data: { idLS: LOADSHEET.idLS, idState: 1 },
													}).then(function (response) {
														if (response.response.code === null) {
															const loadsheet_confirmed = document.querySelector(
																".loadsheet-confirmed",
															);
															loadsheet_confirmed.style.display = "block";
															LOADSHEET = response.loadsheet;
														}
														loader.hide();
														const containerText = document.createElement("div");
														containerText.innerHTML = response.response.text;
														containerText.classList.add(
															"loadsheet-confirmed-modal",
														);

														ModalContainerLoadsheet.open(containerText);
														m.route(`/task/${m.route.param('taskId')}/loadsheet`)
														setTimeout(() => {
															ModalContainerLoadsheet.close();
														}, 2500);
													});
												},
											},
											"Подтвердить",
										),
										m(
											"button.btn-lg.loadsheet-confirm-btn",
											{
												disabled: LOADSHEET.idState === 0 ? false : true,
												class: LOADSHEET.idState === 0 ? "bg-confirm" : "bg-grey",
												onclick: function () {
													m.route(`/task/${ctrl.taskId}/loadsheet/lmc`)
													return
												},
											},
											"Внести LMC",
										),
										m(
											"button.btn-lg.loadsheet-confirm-btn",
											{
												disabled: LOADSHEET.idState === 0 ? false : true,
												class: LOADSHEET.idState === 0 ? "bg-orange" : "bg-grey",
												onclick: function () {
													ctrl.setCancel(true)
												},
											},
											"Отклонить",
										),
									]
									: [
										m('div[style="display:flex;justify-content: space-between; align-items: center;"]', [
											m('strong.text-muted', 'Комментарий'),
											m('span.text-muted', `${ctrl.cancelComment.length}/${ctrl.maxlength}`),
										]),
										m(`textarea.form-control[id='cancelComment'][style='margin-bottom: 10px; resize: none; height: 140px;'][maxlength='${ctrl.maxlength}'][autofocus]`, {
											oninput: function (el) {
												ctrl.setCancelComment(el.target.value)
											}
										},ctrl.cancelComment),
										m(
											"button.btn-lg.loadsheet-confirm-btn",
											{
												disabled: false,
												class:"bg-orange",
												onclick: function () {
													// m.request({
													// 	method: "PUT",
													// 	url: `/api/task/${m.route.param("taskId")}/setLoadSheet`,
													// 	data: {
													// 		idLS:LOADSHEET.idLS, idState: LOADSHEET.idState, reason: ctrl.cancelComment
													// 	}
													// })
													if (ctrl.cancelComment.length > 0 ) {
														ModalContainerReject.init()
														ModalContainerReject.open({
															idLS:LOADSHEET.idLS, idState: 3, reason: ctrl.cancelComment
														})
													} else {
														ModalContainerComment.init()
														ModalContainerComment.open()
													}
													ctrl.setCancel(true)
												},
											},
											"Отклонить",
										),
									],

								m(".loadsheet-maintext", [
									m(".text[style='white-space: pre;']", {
										innerHTML: LOADSHEET.data
									}),
									m(".fullscreen-btn", [
										m(
											"button",
											{
												onclick: function () {
													const container = document.querySelector(
														".loadsheet-maintext",
													);
													const clonedDiv = container.cloneNode(true);

													const fullscreenButton =
														clonedDiv.querySelector(".fullscreen-btn i");

													fullscreenButton.classList.remove("fa-expand");
													fullscreenButton.classList.add("fa-compress");

													fullscreenButton.addEventListener(
														"click",
														function () {
															ModalContainerLoadsheet.close();
														},
													);

													const increaseButton = clonedDiv.querySelectorAll(
														".fontsize-change-btn button",
													)[0];
													const decreaseButton = clonedDiv.querySelectorAll(
														".fontsize-change-btn button",
													)[1];

													increaseButton.addEventListener("click", function () {
														zoomOut(
															`#${MODAL_CONTAINER_ID} .loadsheet-maintext .text`,
														);
													});
													decreaseButton.addEventListener("click", function () {
														zoomIn(
															`#${MODAL_CONTAINER_ID} .loadsheet-maintext .text`,
														);
													});
													ModalContainerLoadsheet.open(clonedDiv);
												},
											},
											[m("i.fa.fa-2x.fa-expand.expand-icon")],
										),
									]),
									m(".fontsize-change-btn", [
										m(
											"button",
											{
												onclick: function () {
													zoomOut(".loadsheet-maintext .text");
												},
											},
											[m("i.fa.fa-2x.fa-minus.expand-icon")],
										),
										m(
											"button",
											{
												onclick: function () {
													zoomIn(".loadsheet-maintext .text");
												},
											},
											[m("i.fa.fa-2x.fa-plus.expand-icon")],
										),
									]),
								]),
							]),
					  ],
			),
		];
	},
};
